/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions, FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions';
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions.js.map